import { toast } from "sonner";
import { updateOpeningInterview } from "./api";
import { useMutation } from "@tanstack/react-query";
import { invalidateAllQueries } from "utils/utils";

function buildPayload(values) {
    if (!values || typeof values !== "object") return {};

    const { applicant, ...rest } = values;

    const payload = {
        ...Object.fromEntries(
            Object.entries(rest).filter(
                ([_, v]) => v !== "" && v !== undefined && v !== null
            )
        ),
        status: values.status,
    };

    if (applicant !== undefined) {
        payload.applicant = applicant?.id;
    }

    return payload;
}

export function useUpdateOpeningInterview() {
    return useMutation({
        mutationFn: async ({ interviewId, values }) => {
            const payload = buildPayload(values);

            try {
                const response = await updateOpeningInterview({ interviewId, item: payload });
                return response;
            } catch (error) {
                throw error;
            }
        },
        onSuccess: () => {
            invalidateAllQueries();
            toast.success("Interview Updated Successfully");
        },
        onError: (error) => {
            toast.error(error.message);
            console.log(error.message);
        },
    });
}
